import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import { Col, Row, Space, DatePicker as AntdDatePicker, Flex, Button, ConfigProvider, Tabs, Card, Badge, Modal } from "antd";
import { DatePicker as DatePickers, Input, RadioGroup, Select } from "components/form";
import { formatDate } from "utils/formatter";
import cx from 'classnames';
import schema, {
  initialValues as INITIAL_VALUES,
} from "../schemas/documentSchema";
import dayjs from "dayjs"
import { WarningOutlined } from "@ant-design/icons";
import styles from '../components/Input.module.css';
import { MY_REQUEST_TYPE } from "../schemas/myRequestSchema";
import { useCallback, useState } from "react";
import { useEffect } from "react";
import * as services from "../services/myDocumentApi";
import { generateRandomString } from "utils/helper";
import { useSelector } from "react-redux";
import StatusTag from "components/elements/TagCustom/StatusTag";
import * as Yup from "yup";
import { REQUEST_APPROVE_TAB } from "features/requestApproval/schemas/RequestApproveTab";
import { ReactComponent as PDFIcon } from "../../../assets/icon/pdfIcon.svg";
import { ReactComponent as DownloadICon } from "../../../assets/icon/downloadIcon.svg";

const { RangePicker } = AntdDatePicker;

const MODAL_TYPE = {
  CREATE: "create",
  EDIT: "edit",
  VIEW: "view",
};

function DocumentForm({
  className = "",
  initialValues = {},
  modalType = "view",
  documentTypeOptions = [],
  countryOptions = [],
  onDraft = () => { },
  onCancel = () => { },
  onSubmit = () => { },
  approvalPage = false,
  standAlone = true,
  onDelete = () => { },
  onReject = () => { },
  onApprove = () => { },
  approveType = "",
  isPDFLoading = false,
  exportDocumentRequest = () => { }
}) {
  const { t, i18n } = useTranslation();
  const [useCurrentMenu, setCurrentMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const [selectedMenu, setMenu] = useState(MY_REQUEST_TYPE.DETAIL);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const [currentWorkflow, setCurrentWorkflow] = useState([]);
  const [openListEmployee, setOpenListEmployee] = useState(false);
  const [listEmployees, setListEmployees] = useState({});

  function formatDateTime(dateString) {
    if (!dateString) return;
    const date = dayjs(dateString);
    return date.format(i18n.language === "en" ? "DD/MM/YYYY HH:mm" : `DD/MM/${date.year() + 543} HH:mm`);
  }

  const handleMenuChange = useCallback(
    (e) => {
      setMenu(e);
    },
    [setMenu]
  );

  function getItem(label, key,) {
    return {
      label: label,
      key: key,
    };
  }

  const MENU = [
    getItem(t("leave_type.label.detail"), MY_REQUEST_TYPE.DETAIL),
    (modalType === MODAL_TYPE.VIEW && initialValues?.approveStatusEn !== 'Draft') ? getItem(t("leave_type.label.approvalSequence"), MY_REQUEST_TYPE.APPROVALSEQ) : null,
    (modalType === MODAL_TYPE.VIEW && (initialValues?.timelineReject?.length > 0)) ? getItem(t("leave_type.label.approvalReqSequence"), MY_REQUEST_TYPE.APPROVALREJECTSEQ) : null,
  ];

  const docSchema = Yup.object().shape({
    documentTypeId: Yup.string().required("Please select."),
    preferredDate: Yup.string().required("Please select."),
    description: Yup.string().required("Please enter.")
  });

  const docSchemaReject = Yup.object().shape({
    descriptionReject: Yup.string().required("Please enter."),
  });

  const getWorkflow = useCallback(async () => {
    let data = [];
    if (modalType === MODAL_TYPE.VIEW && initialValues?.approveStatusEn !== 'Draft') {
      data = await services.getWorkflowByRequestId({
        requestId: generateRandomString(),
        companyId: currentCompany,
        employeeId: initialValues?.employeeId,
        flowRequestId: initialValues?.documentRequestId,
      });
      setCurrentWorkflow(data?.data?.approvalSequence)
    }
  }, [currentCompany, initialValues, modalType])

  useEffect(() => {
    getWorkflow();
  }, [])

  function fnRejectFor(initialValues) {
    let language = i18n.language === 'en' ? "En" : ""

    let condition = initialValues?.rejectWorkflow?.length > 0 ? 1 : 2
    let data = {}
    if (condition == 1) {
      data = initialValues?.rejectWorkflow.map((o, index) => {
        let rejectFlow = initialValues.timelineReject.filter(o => o.approveStatusEn != 'Pending')
        return {
          ...o,
          date: rejectFlow?.[index]?.date ?? null,
          approveStatusEn: rejectFlow?.[index]?.approveStatusEn ?? "Pending",
          approveStatus: rejectFlow?.[index]?.approveStatus ?? "รออนุมัติคำขอ"
        }
      })
    } else {
      data = initialValues.timelineReject
    }

    const hasRejectedStatus = initialValues.timelineReject?.some(item =>
      (item.approveStatusEn === "Rejected"));

    return data?.map((workflow, index) => {
      const isPending = workflow?.approveStatusEn === "Pending";

      const shouldShowGrayStatus = isPending && hasRejectedStatus;

      return (
        <>
          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
            <Row>
              <Col span={16}>
                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
              </Col>
              <Col span={8}>
                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
              </Col>
              <Col span={16}>
                <span>{i18n.language === "en" ? workflow?.employee?.nameAndSurnameEn : workflow?.employee?.nameAndSurname}</span>
              </Col>
              <Col span={8}>
                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.date ? formatDateTime(workflow?.date) : "-"}</span>
              </Col>
              <Col span={16} style={{ marginTop: '10px' }}>
                <span>{i18n.language === "en" ? workflow?.employee?.position?.positionNameEn : workflow?.employee?.position?.positionName}</span>
              </Col>
              <Col span={8} style={{ marginTop: '10px' }}>
                <label style={{ display: "flex", justifyContent: "flex-end" }}>
                  {shouldShowGrayStatus ?
                    <Badge color="#667085" text={workflow?.["approveStatus" + language]} style={{ backgroundColor: "#EAEBEC", borderRadius: "16px", padding: "2px 8px", color: "#667085" }} /> :
                    <StatusTag value={(workflow?.["approveStatus" + language])} />
                  }
                </label>
              </Col>
            </Row>
          </Card>
        </>
      );
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={{
        ...INITIAL_VALUES,
        ...initialValues,
        preferredDate: initialValues?.preferredDate ? dayjs(initialValues?.preferredDate) : null,
        documentTypeId: initialValues?.documentTypeId?.id,
        // RangevisaDate: initialValues?.preferredDate
        countryId: initialValues.country ? initialValues?.country?.id : null,
        rangevisaDate: initialValues?.startTravelDate
          ? [dayjs(initialValues?.startTravelDate), dayjs(initialValues?.endTravelDate)]
          : [null, null],


      }}
      onSubmit={(values, { resetForm }) => { initialValues.reject == 'reject' ? onReject(values) : onSubmit(values, resetForm) }}
      validationSchema={() =>
        initialValues.reject === 'reject' ? docSchemaReject : docSchema
      }

    >
      {({ values = {}, resetForm = () => { }, touched = {}, getFieldMeta = () => { }, setFieldValue }) => {
        const selectedDocumentType = documentTypeOptions.find(option => option.value === values?.documentTypeId);
        let language = i18n.language === 'en' ? "En" : ""

        return (
          <Form className={className}>
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
              <Flex gap={10} vertical>
                <ConfigProvider
                  theme={{
                    components: {
                      Tabs: {
                        itemHoverColor: "var(--tab-color)",
                        itemActiveColor: "var(--tab-color)"
                      },
                    },
                  }}
                >
                  <Tabs items={MENU}
                    onChange={(e) => { handleMenuChange(e); setCurrentMenu(e); }}
                  />
                </ConfigProvider>

                {(selectedMenu === MY_REQUEST_TYPE.DETAIL && (modalType === MODAL_TYPE.CREATE || modalType === MODAL_TYPE.EDIT || modalType === MODAL_TYPE.VIEW)) && (
                  <Row gutter={[0, 12]}>
                    <Col span={24}>
                      <Select
                        disabled={modalType == 'view'}
                        name="documentTypeId"
                        label={t('my_request.label.document-form-type')}
                        placeholder={t('common.pleaseSelect')}
                        size="large"
                        options={documentTypeOptions}
                        required
                      />
                    </Col>

                    <Col span={24}>
                      <DatePickers
                        disabled={modalType == 'view'}
                        name="preferredDate"
                        label={t('my_request.label.preferred-date')}
                        placeholder={t('common.placeholder.ddmmyyyy')}
                        size="large"
                        format={formatDate()}
                        required
                        disabledDate={(current) => current && current < dayjs().startOf('day')}
                      />
                    </Col>
                    {
                      selectedDocumentType?.name === 'หนังสือรับรองการทำงานเพื่อทำวีซ่า' ?
                        <Col span={24}>
                          <Select
                            disabled={modalType == 'view'}
                            name="countryId"
                            label={t('my_request.label.country')}
                            placeholder={t('common.pleaseSelect')}
                            size="large"
                            options={countryOptions}
                            required
                          />
                        </Col>
                        : null
                    }
                    {
                      selectedDocumentType?.name === 'หนังสือรับรองการทำงานเพื่อทำวีซ่า' ?
                        <Col span={24}>
                          <Flex vertical>
                            <label>{t("workin_location.label.duration")}</label>
                            <RangePicker
                              disabled={modalType == 'view'}
                              name="rangevisaDate"
                              placeholder={t('common.placeholder.ddmmyyyy')}
                              size="large"
                              format={i18n.language === "en" ? "DD/MM/YYYY" : "DD/MM/BBBB"}
                              type="range"
                              className={cx({ [styles.errorBorder]: (Array.isArray(values?.rangevisaDate) && (!values?.rangevisaDate[0] || !values?.rangevisaDate[1])) || !values?.rangevisaDate })}
                              onChange={(dates) => {
                                setFieldValue("rangevisaDate", dates);
                              }}
                              minDate={dayjs().startOf("year")}
                              maxDate={dayjs().endOf("year")}
                              value={values?.rangevisaDate}
                            // suffixIcon={
                            //   <CalendarOutlined
                            //     className={cx({ [styles.errorIcon]: touched.rangevisaDate && Array.isArray(values?.rangevisaDate) && (!values?.rangevisaDate[0] || !values?.rangevisaDate[1]) })}
                            //   />
                            // }
                            />
                          </Flex>
                          {
                            (Array.isArray(values?.rangevisaDate) &&
                              (!values?.rangevisaDate[0] || !values?.rangevisaDate[1])) || !values.rangevisaDate ? (
                              <span className={cx("error", styles.error)}>
                                <WarningOutlined /> {t("common.pleaseSelect")}
                              </span>
                            ) : null}

                        </Col>
                        : null

                    }

                    <Col span={24}>
                      <RadioGroup
                        disabled={modalType == 'view'}
                        required
                        name="receivingMethod"
                        label={t('my_request.label.receiving-method')}
                        options={[
                          {
                            label: t('my_request.label.app'),
                            value: "app",
                          },
                          {
                            label: t('employee.label.email'),
                            value: "email",
                          },
                          {
                            label: t('my_request.label.self-service-after-approval'),
                            value: "self_service",
                          },
                        ]}
                      />
                    </Col>
                    <Col span={24}>
                      <RadioGroup
                        disabled={modalType == 'view'}
                        required
                        name="languageFormat"
                        label={t('my_request.label.language-format')}
                        options={[
                          {
                            label: t('my_request.label.both'),
                            value: "both",
                          },
                          {
                            label: t('thai'),
                            value: "th",
                          },
                          {
                            label: t('english'),
                            value: "en",
                          },
                        ]}
                      />
                    </Col>

                    <Col span={24}>
                      <Input
                        disabled={modalType == 'view'}
                        required
                        name="description"
                        label={t('expense.lable.reason')}
                        placeholder={t('expense.lable.pls_fill_reason')}
                        size="large"
                      />
                    </Col>

                    {((initialValues.reject == 'reject') || (Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0)) &&
                      <Col span={24}>
                        <Input
                          disabled={initialValues.reject != 'reject'}
                          type=""
                          name="descriptionReject"
                          label={t('leave_type.label.noteReject')}
                          placeholder={t('leave_type.label.noteReject')}
                          size="large"
                          autoComplete="off"
                          required
                          rows="4"
                        />
                      </Col>
                    }

                    {initialValues?.ableToDownload == "Y" && (
                      <Flex vertical gap={8} style={{ width: "100%" }}>
                        <span>{t("payment.label.download_doc")}</span>

                        <Card
                          style={{ backgroundColor: "#F5F6F7", border: "1px solid #E4E7EC", borderRadius: "12px" }}
                          styles={{ body: { padding: "16px" } }}
                        >
                          <Row style={{ width: "100%" }}>
                            <Col span={16}>
                              <Flex gap={16} align="center">
                                <PDFIcon />
                                <Flex vertical>
                                  <span style={{ fontWeight: "bold", color: "#42526D" }}>{
                                    `${i18n.language === "en"
                                      ? initialValues?.documentTypeId?.nameEn
                                      : initialValues?.documentTypeId?.name}_${i18n.language === "en"
                                        ? dayjs(initialValues?.preferredDate).format("DD/MM/YYYY")
                                        : dayjs(initialValues?.preferredDate).format("DD/MM/BBBB")}`
                                  }</span>
                                  <span style={{ color: "#42526D" }}>{t("common.pdf_file")}</span>
                                </Flex>
                              </Flex>
                            </Col>
                            <Col span={8} style={{ alignContent: "center", justifyItems: "flex-end" }}>
                              <Button
                                type="default"
                                style={{ height: "40px", borderRadius: "8px", display: "flex", alignItems: "center" }}
                                onClick={() => {
                                  const fileName = `${i18n.language === "en"
                                    ? initialValues?.documentTypeId?.nameEn
                                    : initialValues?.documentTypeId?.name}_${i18n.language === "en"
                                      ? dayjs(initialValues?.preferredDate).format("DD/MM/YYYY")
                                      : dayjs(initialValues?.preferredDate).format("DD/MM/BBBB")}`;
                                  exportDocumentRequest(fileName, initialValues?.employeeId)
                                }
                                }
                                icon={
                                  !isPDFLoading ? (
                                    <DownloadICon style={{ fontSize: 16 }} />
                                  ) : (
                                    <span style={{ width: 16, height: 16 }} />
                                  )
                                }
                                loading={isPDFLoading}
                                disabled={isPDFLoading}
                              >
                                <span style={{ color: "#59687F", fontWeight: "bold" }}>{t("common.download")}</span>
                              </Button>
                            </Col>
                          </Row>
                        </Card>
                      </Flex>
                    )}
                  </Row>
                )}

                {selectedMenu === MY_REQUEST_TYPE.APPROVALSEQ && (
                  <>
                    {Array.isArray(currentWorkflow) &&
                      currentWorkflow?.map((workflow, index) => (
                        <>
                          <label>{`${t('leave_type.label.sequence')} ${index + 1}`}</label>
                          <Card size="small" key={index} style={{ border: "1px solid #000" }}>
                            <Row>
                              <Col span={16}>
                                <label style={{ color: "#667085" }}>{`${t('leave_type.label.approver')}`}</label>
                              </Col>
                              <Col span={8}>
                                <span style={{ color: "#667085", display: "flex", justifyContent: "flex-end" }}>{t("leave_type.label.approvalDate")}</span>
                              </Col>
                              <Col span={16}>
                                <span>{workflow?.listEmployees?.slice(0, 3).join(" , ")}</span>
                                <> </>
                                {workflow?.listEmployees?.length > 3 ? (
                                  // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                  <a
                                    onClick={() => {
                                      setOpenListEmployee(true);
                                      setListEmployees(workflow?.listEmployees);
                                    }}
                                    style={{
                                      display: "inline-block",
                                      borderRadius: "36px",
                                      padding: "4px 12px",
                                      fontSize: "0.7vw",
                                      color: "#fff",
                                      background: "var(--primary-color)",
                                      textDecoration: "none",
                                      fontWeight: "bold",
                                      border: "1px solid var(--primary-color)",
                                      cursor: "pointer"
                                    }}

                                  >
                                    {`+ ${workflow?.listEmployees?.length - 3} ...`}
                                  </a>
                                ) : ""}
                              </Col>
                              <Col span={8}>
                                <span style={{ display: "flex", justifyContent: "flex-end" }}>{workflow?.approveDate ? formatDateTime(workflow?.approveDate) : "-"}</span>
                              </Col>
                            </Row>
                            <Row >
                              <Col span={16} style={{ marginTop: '10px' }}>
                                <label>
                                  {workflow?.workFlowtype}
                                </label></Col>
                              <Col span={8} style={{ marginTop: '10px' }} >
                                <label style={{ display: "flex", justifyContent: "flex-end" }}> <StatusTag value={(workflow?.["approveStatus" + language])} /> </label>
                              </Col>
                            </Row>
                          </Card >
                        </>
                      ))}
                  </>
                )}
                {selectedMenu === MY_REQUEST_TYPE.APPROVALREJECTSEQ && (
                  <>
                    {Array.isArray(initialValues.timelineReject) && initialValues?.timelineReject?.length > 0 &&
                      fnRejectFor(initialValues)
                    }
                  </>
                )}

                {selectedMenu === MY_REQUEST_TYPE.DETAIL && approveType === REQUEST_APPROVE_TAB.REQUESTFORM && (
                  <Row justify="end">
                    <Space size={12} className={styles.filterbtn}>
                      <Button
                        type="default"
                        onClick={() => { onReject() }}
                        style={{ height: "40px", borderRadius: "8px", padding: "8px 16px" }}
                      >
                        {t("action.reject")}
                      </Button>
                      <Button
                        type="primary"
                        onClick={() => { onApprove() }}
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px" }}
                      >
                        {t("action.approve")}
                      </Button>
                    </Space>
                  </Row>
                )}
              </Flex>

              {openListEmployee && (
                <Modal title={t("leave_type.label.approver")}
                  open={openListEmployee}
                  onCancel={() => setOpenListEmployee(false)}
                  footer={false}
                  width="510px"
                  maskClosable={false}
                >
                  <Card size="small" style={{ border: "1px solid #000" }}>
                    {listEmployees?.map((employee, index) => (
                      <label key={index}>
                        {employee}
                        <br />
                      </label>
                    ))}
                  </Card>
                </Modal>
              )}

              {standAlone == true &&
                <Row justify="end">
                  <Space direction="horizontal" size={12}>
                    <Button
                      id="mst__cancelBtn"
                      type="default"
                      onClick={() => {
                        resetForm();
                        onCancel();
                      }}
                      style={{ height: "40px", borderRadius: "8px" }}
                    >
                      {t("common.cancel")}
                    </Button>

                    {(initialValues.reject == 'reject' && useCurrentMenu == MY_REQUEST_TYPE.DETAIL) &&
                      <Button
                        htmlType="submit"
                        onClick={() => {
                          setFieldValue("sendingType", "SUBMIT");

                        }}
                        type="primary"
                        style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", boxShadow: "none" }}
                      >
                        {t("common.reject")}
                      </Button>
                    }

                    {modalType != 'view' ?
                      <><Button
                        id="mst__cancelBtn"
                        type="default"
                        onClick={() => onDraft(values)}
                        style={{ height: "40px", borderRadius: "8px" }}
                      >
                        {t("common.draft")}
                      </Button>
                        {modalType === MODAL_TYPE.EDIT && values.sendingType === 'DRAFT' ?
                          <Button
                            type="default"
                            style={{ height: "40px", borderRadius: "8px", color: "red", borderColor: "red" }}
                            onClick={() => {
                              resetForm();
                              onDelete(values);
                            }}
                          >
                            {t("common.delDraft")}
                          </Button>
                          : null}
                        <Button htmlType="submit"
                          onClick={() => {
                            setFieldValue("sendingType", "SUBMIT");
                          }}
                          type="primary"
                          style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)", color: "white", boxShadow: "none" }}>
                          {t("my_timesheet.label.approve")}
                        </Button>
                      </>
                      : null}
                  </Space>
                </Row>
              }
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default DocumentForm;
